import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="email-two-factor"
//
// Drives the email-based 2FA factor screen during sign in: auto-sends the code
// when the screen connects, wires the "resend" button, and runs the cooldown
// countdown. Lives in a Stimulus controller (rather than an inline
// DOMContentLoaded script) so it also runs on Turbo visits, where
// DOMContentLoaded does not fire again.
export default class extends Controller {
  static targets = ["resendButton", "countdown"];
  static values = {
    cooldown: Number,
    sendUrl: String,
  };

  connect() {
    this.timer = null;
    this.sendEmail();
  }

  disconnect() {
    this.clearTimer();
  }

  clearTimer() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  sendEmail() {
    fetch(this.sendUrlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('[name="csrf-token"]').content,
        Accept: "application/json",
      },
      body: JSON.stringify({ type: "email" }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          this.startCountdown(this.cooldownValue);
        } else if (data.remaining_time) {
          this.startCountdown(data.remaining_time);
        } else {
          // the server answers with an i18n key, not a sentence; anything else
          // reaching us (an older server, a proxy) would otherwise be shown as
          // a missing-translation notice
          const fallback = I18n.t("js.authentication.2fa.resend_error");
          alert(
            data.error
              ? I18n.t(data.error, { defaultValue: fallback })
              : fallback,
          );
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        alert(I18n.t("js.authentication.2fa.resend_error"));
      });
  }

  startCountdown(seconds) {
    this.clearTimer();
    let remaining = seconds;

    this.resendButtonTarget.disabled = true;
    this.resendButtonTarget.style.display = "none";
    this.countdownTarget.style.display = "block";
    this.countdownTarget.className =
      "btn btn-link disabled text-muted cursor-pointer btn-sm no-underline";

    const tick = () => {
      if (remaining <= 0) {
        this.resendButtonTarget.disabled = false;
        this.resendButtonTarget.style.display = "inline-block";
        this.countdownTarget.style.display = "none";
        this.clearTimer();
        return;
      }

      this.countdownTarget.textContent = I18n.t(
        "js.authentication.2fa.resend_available_in",
        { seconds: remaining },
      );
      remaining--;
    };

    tick();
    this.timer = setInterval(tick, 1000);
  }
}
